import { render, staticRenderFns } from "./TableTotal.vue?vue&type=template&id=bf07d0ec&scoped=true&"
import script from "./TableTotal.vue?vue&type=script&lang=js&"
export * from "./TableTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf07d0ec",
  null
  
)

export default component.exports